import { createRouter,createWebHashHistory,createWebHistory } from 'vue-router'
import LayoutDefault from "../layout/index.vue";

const routes = [
  {
    path:'/',
    name:'Index',
    component:LayoutDefault,
    redirect: "/",
    meta:{
      iconClass: "iconfont icon-home",
      title: "首页",
    },
    children: [
      {
        path: "/",
        component: () => import("../views/Index/index.vue"),
        name: "Index",
        meta: {
          iconClass: "iconfont icon-home",
          title: "首页",
        },
      },
      {
        path: "/Archives",
        component: () => import("../views/Archives/index.vue"),
        name: "IndexArchives",
        meta: {
          iconClass: "iconfont icon-home",
          title: "档案库",
        },
      },
      {
        path: "/Archives/ActorLibrary/:ActorLibraryId",
        component: () => import("../views/Archives/Components/ActorLibraryDetail/index.vue"),
        name: "IndexArchivesActorLibraryDetail",
        meta: {
          iconClass: "iconfont icon-home",
          title: "演职员详情",
        },
      },
      {
        path: "/Archives/Repertoires/:RepertoiresId",
        component: () => import("../views/Archives/Components/RepertoiresDetail/index.vue"),
        name: "IndexArchivesRepertoiresDetail",
        meta: {
          iconClass: "iconfont icon-home",
          title: "剧目详情",
        },
      },
      {
        path: "/MajorEvents",
        component: () => import("../views/MajorEvents/index.vue"),
        name: "MajorEvents",
        meta: {
          iconClass: "iconfont icon-home",
          title: "重大活动",
        },
      },
      {
        path: "/MajorEvents/:DetailId",
        component: () => import("../views/MajorEventsDetail/index.vue"),
        name: "MajorEventsDetail",
        meta: {
          iconClass: "iconfont icon-home",
          title: "重大活动详情",
        },
      },
      {
        path: "/MediaCoverage",
        component: () => import("../views/MediaCoverage/index.vue"),
        name: "MediaCoverage",
        meta: {
          iconClass: "iconfont icon-home",
          title: "媒体报道",
        },
      },
      {
        path: "/HonorCollection",
        component: () => import("../views/HonorCollection/index.vue"),
        name: "HonorCollection",
        meta: {
          iconClass: "iconfont icon-home",
          title: "荣誉集锦",
        },
      },
      {
        path: "/Sightsee",
        component: () => import("../views/Sightsee/index.vue"),
        name: "Sightsee",
        meta: {
          iconClass: "iconfont icon-home",
          title: "参观游览",
        },
      },
      {
        path: "/FanClub",
        component: () => import("../views/FanClub/index.vue"),
        name: "FanClub",
        meta: {
          iconClass: "iconfont icon-home",
          title: "戏迷俱乐部",
        },
      },
      {
        path: "/FanClub/FanClubActivities",
        component: () => import("../views/FanClubActivities/index.vue"),
        name: "FanClubActivities",
        meta: {
          iconClass: "iconfont icon-home",
          title: "戏迷俱乐部活动",
        },
      },
      {
        path: "/FanClub/FanClubActivities/:DetailId",
        component: () => import("../views/FanClubActivitiesDetail/index.vue"),
        name: "FanClubActivitiesDetail",
        meta: {
          iconClass: "iconfont icon-home",
          title: "戏迷俱乐部活动详情",
        },
      },
      {
        path: "/My",
        component: () => import("../views/My/index.vue"),
        name: "IndexMy",
        meta: {
          iconClass: "iconfont icon-home",
          title: "个人中心",
        },
      },
      {
        path: "/Search",
        component: () => import("../views/Search/index.vue"),
        name: "IndexSearch",
        meta: {
          iconClass: "iconfont icon-home",
          title: "全站搜索",
        },
      },
      {
        path: "/Preview/:DetailId",
        component: () => import("../views/PreviewDetail/index.vue"),
        name: "PreviewDetail",
        meta: {
          iconClass: "iconfont icon-home",
          title: "预览详情",
        },
      },

      

    ]
  },
  {
    path: "/Login",
    component: () => import("@/views/Login/index.vue"),
    name: "Login",
    hidden: true,
    meta: {
      title: "登录",
    },
  },
]

const router = createRouter({
	//createWebHistory = 没有#号
	//createWebHashHistory = 有#号
	history: createWebHistory(),
	routes
})

export default router
